import styled, { css } from 'styled-components';

export const Section = styled.section`
  padding-bottom: 48px;

  @media ${({ theme }) => theme.device.mobileL} {
    margin-bottom: 40px;
  }
`;

const gridTempCols = css`
  --padding-inline: 24px;

  display: grid;
  column-gap: 24px;
  padding-inline: var(--padding-inline);

  @media ${({ theme }) => theme.device.mobileL} {
    --padding-inline: 0;
  }
`;

export const LegendAndCard = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['gridTemplateColumns', 'gridTemplateRows'].includes(prop),
})`
  &:not(:last-child) {
    margin-bottom: 16px;
  }

  > * {
    grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};

    @media ${({ theme }) => theme.device.mobileL} {
      grid-template-rows: ${({ gridTemplateRows }) => gridTemplateRows};
    }
  }

  @media ${({ theme }) => theme.device.mobileL} {
    display: flex;
    border-bottom: 1px solid #8b8b8b;
    padding-block: 24px;

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

export const Legend = styled.div`
  ${gridTempCols}
  margin-bottom: 16px;

  > *:first-child {
    margin-left: calc(var(--padding-inline) * -1);
  }

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 16px;
    grid-template-columns: 90px;
    align-items: center;
    margin-bottom: 0;

    > *:first-child {
      margin-left: 0;
    }
  }
`;

export const EventCard = styled.div`
  ${gridTempCols}
  align-items: center;
  height: 100px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  button {
    margin-left: auto;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    row-gap: 16px;
    grid-template-columns: 1fr;
    text-align: end;
    width: 100%;

    //remove card style
    height: auto;
    border-radius: 0;
    background: none;
    box-shadow: none;

    > .ellipsis {
      white-space: normal; //disable ellipsis
      text-wrap: balance; //make it fancier
    }

    button {
      margin-top: auto;
    }
  }
`;
